import { svgColor, svgUri } from '../../helpers'
import { StyleFn } from '..'

export const IconChevronright = {
  data: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9394 12.0001L8.46973 6.53039L9.53039 5.46973L16.0607 12.0001L9.53039 18.5304L8.46973 17.4697L13.9394 12.0001Z" fill="#080341"></path> </g></svg>',
}

export const Breadcrumb: StyleFn = ({ color, font, size }) => {
  const colors = {
    separator: color.getModalValues(color.border.interactive),
    current: color.type === 'light' ? color.palette.primaryblue[90] : color.palette.white,
  }

  return {
    root: {
      padding: 0,
      margin: 0,
      display: 'flex',
      flexWrap: 'wrap',
    },
    item: {
      listStyle: 'none',
      position: 'relative',
      display: 'inline-flex',
      alignItems: 'center',
      fontSize: font.size.small,
      '& a': {
        fontSize: font.size.small,
      },
      '&:after': {
        content: "''",
        width: size.spacing[16],
        height: size.spacing[16],
        backgroundImage: svgUri(svgColor(IconChevronright.data, colors.separator)),
        backgroundRepeat: 'no-repeat',
        marginBottom: 2,
      },
      '&:last-child:after': {
        display: 'none',
      },
    },
    item_current: {
      margin: `0 ${size.spacing[8]}`,
      color: colors.current,
    },
  }
}
